import { render, staticRenderFns } from "./page-build.vue?vue&type=template&id=1318a7e8&scoped=true"
import script from "./page-build.vue?vue&type=script&lang=js"
export * from "./page-build.vue?vue&type=script&lang=js"
import style0 from "./page-build.vue?vue&type=style&index=0&id=1318a7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318a7e8",
  null
  
)

export default component.exports